var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1171 2.5C15.2346 2.5 16.3096 2.94167 17.1005 3.73417C17.8921 4.525 18.3346 5.59167 18.3346 6.70833V13.2917C18.3346 15.6167 16.443 17.5 14.1171 17.5H5.88464C3.5588 17.5 1.66797 15.6167 1.66797 13.2917V6.70833C1.66797 4.38333 3.55047 2.5 5.88464 2.5H14.1171ZM15.443 7.95L15.5096 7.88333C15.7088 7.64167 15.7088 7.29167 15.5005 7.05C15.3846 6.92583 15.2255 6.85 15.0596 6.83333C14.8846 6.82417 14.718 6.88333 14.5921 7L10.8346 10C10.3513 10.4008 9.6588 10.4008 9.16797 10L5.41797 7C5.1588 6.80833 4.80047 6.83333 4.58464 7.05833C4.35964 7.28333 4.33464 7.64167 4.52547 7.89167L4.63464 8L8.4263 10.9583C8.89297 11.325 9.4588 11.525 10.0513 11.525C10.6421 11.525 11.218 11.325 11.6838 10.9583L15.443 7.95Z",
    fill: "#747B82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageGrey);
export default __webpack_public_path__ + "static/media/messageGrey.108bf4b7.svg";
export { ForwardRef as ReactComponent };